export function formatWorkloadHours(hours?: number | null, fallback = '--') {
  if (hours === null || hours === undefined) {
    return fallback
  }

  return `${hours}h`
}
